import { render, staticRenderFns } from "./VerifyEmailPage.vue?vue&type=template&id=5eecd296"
import script from "./VerifyEmailPage.vue?vue&type=script&lang=js"
export * from "./VerifyEmailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports